<section class="relative md:py-24 py-16">
  <div class="container">
      <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
          <div class="lg:col-span-8 md:col-span-6">
              <div class="relative overflow-hidden rounded-md shadow dark:shadow-gray-800">

                  <img [src]="vorming?.foto" alt="" />

                  <div class="p-6">
                    <h2 class="text-2xl">{{vorming?.titel}}</h2>
                    <h4 class="text-lg">{{vorming?.subtitel}}</h4>
                      <p class="text-slate-400 mt-4" [innerHTML]="vorming?.beschrijving | mdtohtml"></p>
                  </div>
              </div>
          </div>


          <div class="lg:col-span-4 md:col-span-6">
              <div class="sticky top-20">

                  <h5 class="hidden md:block text-lg font-medium bg-earth-try/40 text-black/70 dark:bg-slate-800 shadow dark:shadow-gray-800 rounded-md p-2 text-center">{{vorming?.type}}</h5>
                  <div class="text-center mt-8">
                      <a href="" class="text-lg font-medium hover:text-earth-xdark transition-all duration-500 ease-in-out h5">{{vorming?.titel}}</a>
                      <h4 class="text-md">{{vorming?.subtitel}}</h4>
                      <p class="text-slate-400">{{vorming?.organisator}}</p>
                  </div>

                  <h5 class="text-lg font-medium bg-earth-try/40 text-black/70 dark:bg-slate-800 shadow dark:shadow-gray-800 rounded-md p-2 text-center mt-8">Details</h5>
                  <div class="mt-8 pl-16">
                      <p><i class="uil uil-calendar-alt mr-2"> </i>{{vorming?.date}}</p>
                      <p><i class="uil uil-clock mr-2"> </i>{{vorming?.hour}}</p>
                      <p><i class="uil uil-envelope mr-2" *ngIf="vorming?.contact"> </i>{{vorming?.contact}}</p>
                      <p class="mt-4"><i class="uil uil-map-marker mr-2" *ngIf="vorming?.locatie"> </i><span [innerHTML]="vorming?.locatie | mdtohtml"></span></p>

                  </div>

                  <h5 *ngIf='vorming?.poster' class="text-lg font-medium bg-earth-try/40 text-black/70 dark:bg-slate-800 shadow dark:shadow-gray-800 rounded-md p-2 text-center mt-8">Meer info</h5>
                  <img class='mt-8' *ngIf="vorming?.poster" [src]="vorming?.poster" />
              </div>
          </div>
      </div>
  </div>

  <div class="container lg:mt-24 mt-16">
      <div class="grid grid-cols-1 pb-8 text-center">
          <h3 class="mb-4 md:text-[26px] md:leading-normal text-2xl leading-normal font-semibold">Andere vormingen</h3>

          <p class="text-slate-400 dark:text-slate-300 max-w-xl mx-auto">Bekijk de andere vormingen die we organiseren.</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-[30px] mt-8">

        <div *ngFor="let v of vormingen" class="group relative overflow-hidden bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-700">
              <div class="relative overflow-hidden">
                  <img [src]="v.foto" class="scale-110 group-hover:scale-100 transition-all duration-500" alt="">
              </div>

              <div class="relative p-6">
                  <div class="absolute left-6 -top-4">
                    <span class="bg-earth-try text-black/70 text-[12px] px-2.5 py-1 font-semibold rounded-full h-5">{{v.type}}</span>
                  </div>

                  <div class="">
                    <div class="flex mb-4">
                        <span class="text-slate-400 text-sm"><i class="uil uil-calendar-alt text-slate-900 dark:text-white mr-2"></i>{{v.date}}</span>
                        <span class="text-slate-400 text-sm ml-4"><i class="uil uil-clock text-slate-900 dark:text-white mr-2"></i>{{v.hour}}</span>
                    </div>

                    <a [routerLink]="['/vorming']" [queryParams]="{vorming: v.id}" class="title text-lg font-semibold hover:text-earth-xdark duration-500 ease-in-out">{{v.titel}}</a>

                    <div class="flex justify-between items-center mt-3">
                        <span class="text-slate-400 text-sm">by {{v.organisator}}</span>
                        <a [routerLink]="['/vorming']" [queryParams]="{vorming: v.id}" routerLinkActive="router-link-active" class="btn btn-link hover:text-earth-xdark after:bg-earth-xdark duration-500 ease-in-out">Meer info <i class="uil uil-arrow-right"></i></a>
                    </div>
                  </div>
              </div>
          </div>
          <!--end content-->
      </div><!--end grid-->
  </div><!--end container-->

</section>
